import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { AdminPortal } from "../app/admin-portal";
import "../app/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Perza Admin root element was not found.");

createRoot(root).render(
  <StrictMode>
    <AdminPortal />
  </StrictMode>,
);
